"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JSONLogicModule = exports.interpolate = exports.evaluate = exports.JSONLogicEvaluator = void 0;
const formUtil_1 = require("../../utils/formUtil");
const jsonLogic_1 = require("./jsonLogic");
const Evaluator_1 = require("../../utils/Evaluator");
class JSONLogicEvaluator extends Evaluator_1.BaseEvaluator {
  static evaluate(func, args = {}, ret = '', interpolate = false, context = {}, options = {}) {
    let returnVal = null;
    if (typeof func === 'object') {
      try {
        returnVal = jsonLogic_1.jsonLogic.apply(func, args);
      } catch (err) {
        returnVal = null;
        console.warn(`An error occured within JSON Logic`, err);
      }
    } else {
      returnVal = Evaluator_1.BaseEvaluator.evaluate(func, args, ret, interpolate, context, options);
    }
    return returnVal;
  }
}
exports.JSONLogicEvaluator = JSONLogicEvaluator;
function evaluate(context, evaluation, ret = 'result', evalContextFn, options = {}) {
  const {
    evalContext,
    instance
  } = context;
  const evalContextValue = evalContext ? evalContext((0, formUtil_1.normalizeContext)(context)) : (0, formUtil_1.normalizeContext)(context);
  if (evalContextFn) {
    evalContextFn(evalContextValue);
  }
  if (instance && instance.evaluate) {
    return instance.evaluate(evaluation, evalContextValue, ret, false, options);
  }
  return JSONLogicEvaluator.evaluate(evaluation, evalContextValue, ret, false, context, options);
}
exports.evaluate = evaluate;
function interpolate(context, evaluation, evalContextFn) {
  const {
    evalContext,
    instance
  } = context;
  const evalContextValue = evalContext ? evalContext((0, formUtil_1.normalizeContext)(context)) : (0, formUtil_1.normalizeContext)(context);
  if (evalContextFn) {
    evalContextFn(evalContextValue);
  }
  if (instance && instance.evaluate) {
    return instance.interpolate(evaluation, evalContextValue, {
      noeval: true
    });
  }
  return JSONLogicEvaluator.interpolate(evaluation, evalContextValue, {
    noeval: true
  });
}
exports.interpolate = interpolate;
__exportStar(require("./jsonLogic"), exports);
exports.JSONLogicModule = {
  evaluator: JSONLogicEvaluator
};